import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import FuzzyText from "@/components/animatedComponents/FuzzyText";

interface ErrorPageProps {
  code?: number;
  title?: string;
}

const NotFound: React.FC<ErrorPageProps> = ({
  code = 404,
  title = "Oops! Page not found",
}) => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      `${code} Error: User attempted to access non-existent route:`,
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#f5f5f5]">
      <div className="mb-5">
        <FuzzyText
          baseIntensity={0.1}
          hoverIntensity={0.3}
          color="#0d1821"
          fontFamily="orbitron"
          fontSize="clamp(2.25rem, 5vw, 6rem)"
          fontWeight={500}
        >
          {code}
        </FuzzyText>
      </div>
      <div className="mb-4">
        <FuzzyText
          baseIntensity={0.05}
          hoverIntensity={0.15}
          color="#00a878"
          fontFamily="orbitron"
          fontSize="clamp(1.25rem, 2vw, 4rem)"
          fontWeight={500}
        >
          {title}
        </FuzzyText>
      </div>
      <a href="/">
        <FuzzyText
          baseIntensity={0.05}
          hoverIntensity={0.15}
          color="#0d1821"
          fontFamily="orbitron"
          fontSize="clamp(1rem, 1vw, 3rem)"
          fontWeight={400}
        >
          Return to Home &rarr;
        </FuzzyText>
      </a>
    </div>
  );
};

export default NotFound;
